// 国家编码--REX--2025/12/18
export const COUNTRY_NAME_AND_TWOCODE = [
    {"label": "AF-Afghanistan", "value": "AF"},
    {"label": "AX-Åland Islands", "value": "AX"},
    {"label": "AL-Albania", "value": "AL"},
    {"label": "DZ-Algeria", "value": "DZ"},
    {"label": "AS-American Samoa", "value": "AS"},
    {"label": "AD-Andorra", "value": "AD"},
    {"label": "AO-Angola", "value": "AO"},
    {"label": "AI-Anguilla", "value": "AI"},
    {"label": "AQ-Antarctica", "value": "AQ"},
    {"label": "AG-Antigua and Barbuda", "value": "AG"},
    {"label": "AR-Argentina", "value": "AR"},
    {"label": "AM-Armenia", "value": "AM"},
    {"label": "AW-Aruba", "value": "AW"},
    {"label": "AU-Australia", "value": "AU"},
    {"label": "AT-Austria", "value": "AT"},
    {"label": "AZ-Azerbaijan", "value": "AZ"},
    {"label": "BS-Bahamas", "value": "BS"},
    {"label": "BH-Bahrain", "value": "BH"},
    {"label": "BD-Bangladesh", "value": "BD"},
    {"label": "BB-Barbados", "value": "BB"},
    {"label": "BY-Belarus", "value": "BY"},
    {"label": "BE-Belgium", "value": "BE"},
    {"label": "BZ-Belize", "value": "BZ"},
    {"label": "BJ-Benin", "value": "BJ"},
    {"label": "BM-Bermuda", "value": "BM"},
    {"label": "BT-Bhutan", "value": "BT"},
    {"label": "BO-Bolivia (Plurinational State of)", "value": "BO"},
    {"label": "BQ-Bonaire, Sint Eustatius and Saba", "value": "BQ"},
    {"label": "BA-Bosnia and Herzegovina", "value": "BA"},
    {"label": "BW-Botswana", "value": "BW"},
    {"label": "BV-Bouvet Island", "value": "BV"},
    {"label": "BR-Brazil", "value": "BR"},
    {"label": "IO-British Indian Ocean Territory", "value": "IO"},
    {"label": "BN-Brunei Darussalam", "value": "BN"},
    {"label": "BG-Bulgaria", "value": "BG"},
    {"label": "BF-Burkina Faso", "value": "BF"},
    {"label": "BI-Burundi", "value": "BI"},
    {"label": "CV-Cabo Verde", "value": "CV"},
    {"label": "KH-Cambodia", "value": "KH"},
    {"label": "CM-Cameroon", "value": "CM"},
    {"label": "CA-Canada", "value": "CA"},
    {"label": "KY-Cayman Islands", "value": "KY"},
    {"label": "CF-Central African Republic", "value": "CF"},
    {"label": "TD-Chad", "value": "TD"},
    {"label": "CL-Chile", "value": "CL"},
    {"label": "CN-China", "value": "CN"},
    {"label": "CX-Christmas Island", "value": "CX"},
    {"label": "CC-Cocos (Keeling) Islands", "value": "CC"},
    {"label": "CO-Colombia", "value": "CO"},
    {"label": "KM-Comoros", "value": "KM"},
    {"label": "CG-Congo", "value": "CG"},
    {"label": "CD-Congo (Democratic Republic of the)", "value": "CD"},
    {"label": "CK-Cook Islands", "value": "CK"},
    {"label": "CR-Costa Rica", "value": "CR"},
    {"label": "CI-Côte d'Ivoire", "value": "CI"},
    {"label": "HR-Croatia", "value": "HR"},
    {"label": "CU-Cuba", "value": "CU"},
    {"label": "CW-Curaçao", "value": "CW"},
    {"label": "CY-Cyprus", "value": "CY"},
    {"label": "CZ-Czechia", "value": "CZ"},
    {"label": "DK-Denmark", "value": "DK"},
    {"label": "DJ-Djibouti", "value": "DJ"},
    {"label": "DM-Dominica", "value": "DM"},
    {"label": "DO-Dominican Republic", "value": "DO"},
    {"label": "EC-Ecuador", "value": "EC"},
    {"label": "EG-Egypt", "value": "EG"},
    {"label": "SV-El Salvador", "value": "SV"},
    {"label": "GQ-Equatorial Guinea", "value": "GQ"},
    {"label": "ER-Eritrea", "value": "ER"},
    {"label": "EE-Estonia", "value": "EE"},
    {"label": "SZ-Eswatini", "value": "SZ"},
    {"label": "ET-Ethiopia", "value": "ET"},
    {"label": "FK-Falkland Islands (Malvinas)", "value": "FK"},
    {"label": "FO-Faroe Islands", "value": "FO"},
    {"label": "FJ-Fiji", "value": "FJ"},
    {"label": "FI-Finland", "value": "FI"},
    {"label": "FR-France", "value": "FR"},
    {"label": "GF-French Guiana", "value": "GF"},
    {"label": "PF-French Polynesia", "value": "PF"},
    {"label": "TF-French Southern Territories", "value": "TF"},
    {"label": "GA-Gabon", "value": "GA"},
    {"label": "GM-Gambia", "value": "GM"},
    {"label": "GE-Georgia", "value": "GE"},
    {"label": "DE-Germany", "value": "DE"},
    {"label": "GH-Ghana", "value": "GH"},
    {"label": "GI-Gibraltar", "value": "GI"},
    {"label": "GR-Greece", "value": "GR"},
    {"label": "GL-Greenland", "value": "GL"},
    {"label": "GD-Grenada", "value": "GD"},
    {"label": "GP-Guadeloupe", "value": "GP"},
    {"label": "GU-Guam", "value": "GU"},
    {"label": "GT-Guatemala", "value": "GT"},
    {"label": "GG-Guernsey", "value": "GG"},
    {"label": "GN-Guinea", "value": "GN"},
    {"label": "GW-Guinea-Bissau", "value": "GW"},
    {"label": "GY-Guyana", "value": "GY"},
    {"label": "HT-Haiti", "value": "HT"},
    {"label": "HM-Heard Island and McDonald Islands", "value": "HM"},
    {"label": "VA-Holy See", "value": "VA"},
    {"label": "HN-Honduras", "value": "HN"},
    {"label": "HK-Hong Kong", "value": "HK"},
    {"label": "HU-Hungary", "value": "HU"},
    {"label": "IS-Iceland", "value": "IS"},
    {"label": "IN-India", "value": "IN"},
    {"label": "ID-Indonesia", "value": "ID"},
    {"label": "IR-Iran (Islamic Republic of)", "value": "IR"},
    {"label": "IQ-Iraq", "value": "IQ"},
    {"label": "IE-Ireland", "value": "IE"},
    {"label": "IM-Isle of Man", "value": "IM"},
    {"label": "IL-Israel", "value": "IL"},
    {"label": "IT-Italy", "value": "IT"},
    {"label": "JM-Jamaica", "value": "JM"},
    {"label": "JP-Japan", "value": "JP"},
    {"label": "JE-Jersey", "value": "JE"},
    {"label": "JO-Jordan", "value": "JO"},
    {"label": "KZ-Kazakhstan", "value": "KZ"},
    {"label": "KE-Kenya", "value": "KE"},
    {"label": "KI-Kiribati", "value": "KI"},
    {"label": "KP-Korea (Democratic People's Republic of)", "value": "KP"},
    {"label": "KR-Korea (Republic of)", "value": "KR"},
    {"label": "KW-Kuwait", "value": "KW"},
    {"label": "KG-Kyrgyzstan", "value": "KG"},
    {"label": "LA-Lao People's Democratic Republic", "value": "LA"},
    {"label": "LV-Latvia", "value": "LV"},
    {"label": "LB-Lebanon", "value": "LB"},
    {"label": "LS-Lesotho", "value": "LS"},
    {"label": "LR-Liberia", "value": "LR"},
    {"label": "LY-Libya", "value": "LY"},
    {"label": "LI-Liechtenstein", "value": "LI"},
    {"label": "LT-Lithuania", "value": "LT"},
    {"label": "LU-Luxembourg", "value": "LU"},
    {"label": "MO-Macao", "value": "MO"},
    {"label": "MG-Madagascar", "value": "MG"},
    {"label": "MW-Malawi", "value": "MW"},
    {"label": "MY-Malaysia", "value": "MY"},
    {"label": "MV-Maldives", "value": "MV"},
    {"label": "ML-Mali", "value": "ML"},
    {"label": "MT-Malta", "value": "MT"},
    {"label": "MH-Marshall Islands", "value": "MH"},
    {"label": "MQ-Martinique", "value": "MQ"},
    {"label": "MR-Mauritania", "value": "MR"},
    {"label": "MU-Mauritius", "value": "MU"},
    {"label": "YT-Mayotte", "value": "YT"},
    {"label": "MX-Mexico", "value": "MX"},
    {"label": "FM-Micronesia (Federated States of)", "value": "FM"},
    {"label": "MD-Moldova (Republic of)", "value": "MD"},
    {"label": "MC-Monaco", "value": "MC"},
    {"label": "MN-Mongolia", "value": "MN"},
    {"label": "ME-Montenegro", "value": "ME"},
    {"label": "MS-Montserrat", "value": "MS"},
    {"label": "MA-Morocco", "value": "MA"},
    {"label": "MZ-Mozambique", "value": "MZ"},
    {"label": "MM-Myanmar", "value": "MM"},
    {"label": "NAM-Namibia", "value": "NAM"},
    {"label": "NR-Nauru", "value": "NR"},
    {"label": "NP-Nepal", "value": "NP"},
    {"label": "NL-Netherlands", "value": "NL"},
    {"label": "NC-New Caledonia", "value": "NC"},
    {"label": "NZ-New Zealand", "value": "NZ"},
    {"label": "NI-Nicaragua", "value": "NI"},
    {"label": "NE-Niger", "value": "NE"},
    {"label": "NG-Nigeria", "value": "NG"},
    {"label": "NU-Niue", "value": "NU"},
    {"label": "NF-Norfolk Island", "value": "NF"},
    {"label": "MK-North Macedonia", "value": "MK"},
    {"label": "MP-Northern Mariana Islands", "value": "MP"},
    {"label": "NO-Norway", "value": "NO"},
    {"label": "OM-Oman", "value": "OM"},
    {"label": "PK-Pakistan", "value": "PK"},
    {"label": "PW-Palau", "value": "PW"},
    {"label": "PS-Palestine, State of", "value": "PS"},
    {"label": "PA-Panama", "value": "PA"},
    {"label": "PG-Papua New Guinea", "value": "PG"},
    {"label": "PY-Paraguay", "value": "PY"},
    {"label": "PE-Peru", "value": "PE"},
    {"label": "PH-Philippines", "value": "PH"},
    {"label": "PN-Pitcairn", "value": "PN"},
    {"label": "PL-Poland", "value": "PL"},
    {"label": "PT-Portugal", "value": "PT"},
    {"label": "PR-Puerto Rico", "value": "PR"},
    {"label": "QA-Qatar", "value": "QA"},
    {"label": "RE-Réunion", "value": "RE"},
    {"label": "RO-Romania", "value": "RO"},
    {"label": "RU-Russian Federation", "value": "RU"},
    {"label": "RW-Rwanda", "value": "RW"},
    {"label": "BL-Saint Barthélemy", "value": "BL"},
    {"label": "SH-Saint Helena, Ascension and Tristan da Cunha", "value": "SH"},
    {"label": "KN-Saint Kitts and Nevis", "value": "KN"},
    {"label": "LC-Saint Lucia", "value": "LC"},
    {"label": "MF-Saint Martin (French part)", "value": "MF"},
    {"label": "PM-Saint Pierre and Miquelon", "value": "PM"},
    {"label": "VC-Saint Vincent and the Grenadines", "value": "VC"},
    {"label": "WS-Samoa", "value": "WS"},
    {"label": "SM-San Marino", "value": "SM"},
    {"label": "ST-Sao Tome and Principe", "value": "ST"},
    {"label": "SA-Saudi Arabia", "value": "SA"},
    {"label": "SN-Senegal", "value": "SN"},
    {"label": "RS-Serbia", "value": "RS"},
    {"label": "SC-Seychelles", "value": "SC"},
    {"label": "SL-Sierra Leone", "value": "SL"},
    {"label": "SG-Singapore", "value": "SG"},
    {"label": "SX-Sint Maarten (Dutch part)", "value": "SX"},
    {"label": "SK-Slovakia", "value": "SK"},
    {"label": "SI-Slovenia", "value": "SI"},
    {"label": "SB-Solomon Islands", "value": "SB"},
    {"label": "SO-Somalia", "value": "SO"},
    {"label": "ZA-South Africa", "value": "ZA"},
    {"label": "GS-South Georgia and the South Sandwich Islands", "value": "GS"},
    {"label": "SS-South Sudan", "value": "SS"},
    {"label": "ES-Spain", "value": "ES"},
    {"label": "LK-Sri Lanka", "value": "LK"},
    {"label": "SD-Sudan", "value": "SD"},
    {"label": "SR-Suriname", "value": "SR"},
    {"label": "SJ-Svalbard and Jan Mayen", "value": "SJ"},
    {"label": "SE-Sweden", "value": "SE"},
    {"label": "CH-Switzerland", "value": "CH"},
    {"label": "SY-Syrian Arab Republic", "value": "SY"},
    {"label": "TW-Taiwan, Province of China", "value": "TW"},
    {"label": "TJ-Tajikistan", "value": "TJ"},
    {"label": "TZ-Tanzania, United Republic of", "value": "TZ"},
    {"label": "TH-Thailand", "value": "TH"},
    {"label": "TL-Timor-Leste", "value": "TL"},
    {"label": "TG-Togo", "value": "TG"},
    {"label": "TK-Tokelau", "value": "TK"},
    {"label": "TO-Tonga", "value": "TO"},
    {"label": "TT-Trinidad and Tobago", "value": "TT"},
    {"label": "TN-Tunisia", "value": "TN"},
    {"label": "TR-Türkiye", "value": "TR"},
    {"label": "TM-Turkmenistan", "value": "TM"},
    {"label": "TC-Turks and Caicos Islands", "value": "TC"},
    {"label": "TV-Tuvalu", "value": "TV"},
    {"label": "UG-Uganda", "value": "UG"},
    {"label": "UA-Ukraine", "value": "UA"},
    {"label": "AE-United Arab Emirates", "value": "AE"},
    {"label": "GB-United Kingdom of Great Britain and Northern Ireland", "value": "GB"},
    {"label": "US-United States of America", "value": "US"},
    {"label": "UM-United States Minor Outlying Islands", "value": "UM"},
    {"label": "UY-Uruguay", "value": "UY"},
    {"label": "UZ-Uzbekistan", "value": "UZ"},
    {"label": "VU-Vanuatu", "value": "VU"},
    {"label": "VE-Venezuela (Bolivarian Republic of)", "value": "VE"},
    {"label": "VN-Viet Nam", "value": "VN"},
    {"label": "VG-Virgin Islands (British)", "value": "VG"},
    {"label": "VI-Virgin Islands (U.S.)", "value": "VI"},
    {"label": "WF-Wallis and Futuna", "value": "WF"},
    {"label": "EH-Western Sahara", "value": "EH"},
    {"label": "YE-Yemen", "value": "YE"},
    {"label": "ZM-Zambia", "value": "ZM"},
    {"label": "ZW-Zimbabwe", "value": "ZW"}
  ]